<template>
  <v-card class="text-xs-center">
    <h1 class="pa-3">Action Events Log</h1>
    <div class="px-5">
      <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs3>
          <v-select
            label="Select Province"
            :items="provinceData"
            item-value="province_name_en"
            item-text="province_name_th"
            v-model="config.province"
            @change="init()"
          ></v-select>
        </v-flex>
      </v-layout>
    </div>
    <log-table
      @fetch="init()"
      :config="config"
      :itemList="data"
      :isLoading="isLoading"
    />
  </v-card>
</template>

<script>
import LogTable from "@/components/back-office/Merchant/ActionsEventLog/dataEventTable.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      data: [],
      page_size: 0,
      current_page: 1,
      config: {
        province: "Phuket",
        page_size: 15,
        current_page: 1,
        totalItems: 0,
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState({
      eventLogApproval: (state) => state.fetchStoreApproveBack.eventLogApproval,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      fetchData: "fetchStoreApproveBack/getEventLogAction",
    }),
    async init() {
      this.isLoading = true;
      let result = await this.fetchData(this.config);
      this.data = result.data;
      this.config.totalItems = result.length;
      this.isLoading = false;
    },
  },
  components: { "log-table": LogTable },
  destroyed() {
    this.$store.commit("fetchStoreApproveBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Event Action Logs",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
